export default "__VITE_ASSET__d9d4f7b9__"